import map from 'lodash/map'
import { LogisticStatus } from '@ztechapps/logistic.common'

export const logisticStatusOptions = map(LogisticStatus, (item) => {
  return { label: item.value, value: item.value }
})
